import { render, staticRenderFns } from "./PlatformReceiptsPaymentsStatements.vue?vue&type=template&id=68b330ce&scoped=true&"
import script from "./PlatformReceiptsPaymentsStatements.vue?vue&type=script&lang=js&"
export * from "./PlatformReceiptsPaymentsStatements.vue?vue&type=script&lang=js&"
import style0 from "./PlatformReceiptsPaymentsStatements.vue?vue&type=style&index=0&id=68b330ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b330ce",
  null
  
)

export default component.exports